import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'
import {SegmentDataValueObject} from './SegmentDataValueObject.js'

export class SegmentValueObject {
  #event
  #data

  constructor({event, data}) {
    this.#event = event
    this.#data = data
  }

  static create({
    channel,
    eventName,
    hitOrigin,
    hitInformation,
    hitInformation2,
    brandId,
    modelId,
    pageCategoryLevel1,
    pageName,
    pageType
  }) {
    return new SegmentValueObject({
      event: StringSharedValueObject.create({value: eventName}),
      data: SegmentDataValueObject.create({
        channel,
        hitOrigin,
        hitInformation,
        hitInformation2,
        brandId,
        modelId,
        pageCategoryLevel1,
        pageName,
        pageType
      })
    })
  }

  get data() {
    return this.#data.value
  }

  get event() {
    return this.#event.value
  }

  get value() {
    return {
      event: this.event,
      data: this.data
    }
  }

  toSegmentTrack() {
    return {
      event: this.#event.value,
      data: this.#data.getValueToSnakeCase()
    }
  }
}
